// extracted by mini-css-extract-plugin
module.exports = {"h2":"_1lCQTX","base":"_1Aritn","main":"ioehZd","RawWrapper":"_2OmDAQ","RawBody":"_26okx5"};